import { Children } from "react";
import MenuHeader from "./MenuHeader";
import MenuDivider from "./MenuDivider";
// MenuHeader and MenuDivider can't be indexed
export var skipTypes = [MenuHeader, MenuDivider];
/**
 * Finds the first valid item index
 *
 * @param {Array} children
 */
export function findFirstTabbableIndex(children) {
    return Children.toArray(children).findIndex(function (child) {
        var isSkippableType = !!skipTypes.find(function (type) {
            return type === child.type || (child.type.target && type === child.type.target);
        });
        return !isSkippableType && !child.props.disabled;
    });
}
/**
 * Finds the last valid item index
 *
 * @param {Array} children
 */
export function findLastTabbableIndex(children) {
    var childrenArray = Children.toArray(children);
    var childrenCount = Children.count(children);
    var index = childrenArray.reverse().findIndex(function (child) {
        var isSkippableType = !!skipTypes.find(function (type) {
            return type === child.type || (child.type.target && type === child.type.target);
        });
        return !isSkippableType && !child.props.disabled;
    });
    return childrenCount - index - 1;
}
/**
 * Finds the next valid item index
 *
 * @param {Array} children
 * @param {Number} currentIndex
 */
export function findNextTabbableIndex(children, currentIndex) {
    return Children.toArray(children).findIndex(function (child, index) {
        var isSkippableType = !!skipTypes.find(function (type) {
            return type === child.type || (child.type.target && type === child.type.target);
        });
        return !isSkippableType && index > currentIndex && !child.props.disabled;
    });
}
/**
 * Finds the previous valid item index
 *
 * @param {Array} children
 * @param {Number} currentIndex
 */
export function findPrevTabbableIndex(children, currentIndex) {
    var childrenArray = Children.toArray(children);
    var childrenCount = childrenArray.length;
    var index = -1;
    if (currentIndex === -1) {
        return childrenCount - 1;
    }
    var _loop_1 = function (i) {
        var child = childrenArray[i];
        var isSkippableType = !!skipTypes.find(function (type) {
            return type === child.type || (child.type.target && type === child.type.target);
        });
        if (!isSkippableType && i < currentIndex && !child.props.disabled) {
            index = i;
            return "break";
        }
    };
    for (var i = childrenCount - 1; i >= 0; i--) {
        var state_1 = _loop_1(i);
        if (state_1 === "break")
            break;
    }
    if (index === -1) {
        return childrenCount - 1;
    }
    return index;
}
/**
 * Finds the next valid index by character
 *
 * @param {Array} children
 * @param {String} char
 * @param {Number} focusIndex
 */
export function findNextTabbaleIndexByChar(children, char, focusIndex) {
    return Children.toArray(children).findIndex(function (child, index) {
        if (index > focusIndex &&
            typeof child.props.children === "string" &&
            !child.props.disabled) {
            return (child.props.children.charAt(0).toLowerCase() === char.toLowerCase());
        }
        return false;
    });
}
